import { styled } from "@mui/material/styles";
const Header = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "17px",
  "& .arrows": {
    width: "14%",
  },
}));
const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "35px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
}));
const FormMain = styled("div")(({ theme }) => ({
  "& .AuthInputMain": {
    marginBottom: "100px",
  },
  [theme.breakpoints.up("lg")]: {
    marginLeft: "3.9rem",
  },
}));

export { Header, Maincontant, FormMain };
